<template>
  <div class="system-overview">
    <!--温度系统概览 -->
    <div class="con" v-show="!svgmask">
      <div class="con-top">
        <div class="system-item statistics">
          <div class="item-telte"><span id="fullscreen">数据统计</span></div>
          <div class="item-con">
            <div class="statistics-item data1">
              <div class="left-img">
                <img src="../../assets/unifyImg/wendu/gaoya.png" alt="">
                <span>高压室</span>
              </div>
              <div class="middle-num mimmm">
                <div class="explain">温度(°C)</div>
                <div class="allnum">{{value1}}</div>
                <img src="../../assets/unifyImg/vector1.png" alt="">
              </div>
              <div class="middle-num">
                <div class="explain">湿度(%)</div>
                <div class="allnum">{{value4}}</div>
                <img src="../../assets/unifyImg/vector1.png" alt="">
              </div>
            </div>
            <div class="statistics-item data2">
              <div class="left-img">
                <img src="../../assets/unifyImg/charging.png" alt="">
                <span style="color:#3286FF">低压室</span>
              </div>
              <div class="middle-num mimmm">
                <div class="explain">温度(°C)</div>
                <div class="allnum">{{value2}}</div>
                <img src="../../assets/unifyImg/vector2.png" alt="">
              </div>
              <div class="middle-num">
                <div class="explain">湿度(%)</div>
                <div class="allnum">{{value5}}</div>
                <img src="../../assets/unifyImg/vector2.png" alt="">
              </div>
            </div>
            <div class="statistics-item data3">
              <div class="left-img">
                <img src="../../assets/unifyImg/wendu/bianya.png" alt="">
                <span style="color:#3DD0C6">变压器</span>
              </div>
              <div class="middle-num mimmm">
                <div class="explain">温度(°C)</div>
                <div class="allnum">{{value3}}</div>
                <img src="../../assets/unifyImg/vector3.png" alt="">
              </div>
              <div class="middle-num">
                <div class="explain">湿度(%)</div>
                <div class="allnum">{{value6}}</div>
                <img src="../../assets/unifyImg/vector3.png" alt="">
              </div>
            </div>
          </div>
        </div>
        <div class="system-item system-itemM">
          <div class="item-telte"><span>接线图</span></div>
          <div class="svg-con">
            <webSvgPlayer :svgpath="realPath" ref="webSvgPlayer" class="webSvgPlayer" slot="body"></webSvgPlayer>
            <img src="../../assets/unifyImg/enlarge.png" alt="" @click="svgmask = true">
          </div>
        </div>
        <div class="system-item">
          <div class="item-telte"><span>设备状态</span></div>
          <div class="device-items">
            <div class="state-item">
              <div class="left-img">
                <img src="../../assets/unifyImg/fireAlarm.png" alt="">
              </div>
              <div class="right-explain">
                <p>1号设备</p>
                <div class="mystate myruning">
                  <img src="../../assets/unifyImg/runing.png" alt="">
                  <span>正常</span>
                </div>
              </div>
            </div>
            <div class="state-item">
              <div class="left-img">
                <img src="../../assets/unifyImg/fireAlarm.png" alt="">
              </div>
              <div class="right-explain">
                <p>2号设备</p>
                <div class="mystate myruning">
                  <img src="../../assets/unifyImg/runing.png" alt="">
                  <span>正常</span>
                </div>
              </div>
            </div>
            <div class="state-item">
              <div class="left-img">
                <img src="../../assets/unifyImg/fireAlarm.png" alt="">
              </div>
              <div class="right-explain">
                <p>3号设备</p>
                <div class="mystate myruning">
                  <img src="../../assets/unifyImg/runing.png" alt="">
                  <span>正常</span>
                </div>
              </div>
            </div>
            <div class="state-item">
              <div class="left-img">
                <img src="../../assets/unifyImg/fireAlarm.png" alt="">
              </div>
              <div class="right-explain">
                <p>4号设备</p>
                <div class="mystate myruning">
                  <img src="../../assets/unifyImg/runing.png" alt="">
                  <span>正常</span>
                </div>
              </div>
            </div>
            <div class="state-item">
              <div class="left-img">
                <img src="../../assets/unifyImg/fireAlarm.png" alt="">
              </div>
              <div class="right-explain">
                <p>5号设备</p>
                <div class="mystate mystop">
                  <img src="../../assets/unifyImg/stop.png" alt="">
                  <span>异常</span>
                </div>
              </div>
            </div>
            <div class="state-item">
              <div class="left-img">
                <img src="../../assets/unifyImg/fireAlarm.png" alt="">
              </div>
              <div class="right-explain">
                <p>6号设备</p>
                <div class="mystate mystop">
                  <img src="../../assets/unifyImg/stop.png" alt="">
                  <span>异常</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="con-bottom">
        <div class="system-item">
          <div class="item-telte"><span>温度曲线</span></div>
          <div class="mychart">
            <div id="energy" style="width:100%;height:100%"></div>
          </div>
        </div>
        <div class="system-item system-itemM">
          <div class="item-telte"><span>温度趋势曲线</span></div>
          <div class="mychart">
            <div id="energy2" style="width:100%;height:100%"></div>
            <!-- <img src="../../assets/unifyImg/yestop.png" alt="" style="height: 100%;width: 100%;"> -->
            <!-- <img src="../../assets/unifyImg/yeruning.gif" alt="" style="height: 100%;width: 100%;"> -->
          </div>
        </div>
        <div class="system-item">
          <div class="item-telte"><span>实时告警</span></div>
          <div class="mylist">
            <div class="alarm-item">
              <div class="alarm-con">1号设备温度过高</div>
              <div class="alarm-timer">04/10 10:40</div>
            </div>
            <div class="alarm-item">
              <div class="alarm-con">2号设备温度过高</div>
              <div class="alarm-timer">04/10 10:30</div>
            </div>
            <div class="alarm-item">
              <div class="alarm-con">3号设备温度过高</div>
              <div class="alarm-timer">04/10 10:25</div>
            </div>
            <div class="alarm-item">
              <div class="alarm-con">4号设备温度过高</div>
              <div class="alarm-timer">04/10 10:20</div>
            </div>
            <div class="alarm-item">
              <div class="alarm-con">5号设备温度过高</div>
              <div class="alarm-timer">04/10 10:15</div>
            </div>
            <div class="alarm-item">
              <div class="alarm-con">6号设备温度过高</div>
              <div class="alarm-timer">04/10 10:10</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- svg图放大 -->
    <div class="mymask" v-show="svgmask">
      <div class="closeimg">
        <img src="../../assets/unifyImg/close.png" alt="" @click="svgmask = false">
      </div>
      <div class="svg-con">
        <webSvgPlayer :svgpath="realPath" ref="webSvgPlayer" class="webSvgPlayer" slot="body"></webSvgPlayer>
      </div>
    </div>

  </div>
</template>

<script>
  var proportion, proportion2;
  import webSvgPlayer from '@/components/module/svg/webSvgPlayer.vue'
  export default {
    // 在页面组件内部定义导航守卫
    // beforeRouteLeave(to, from, next) {
    //   next(false);
    // },
    components: {
      webSvgPlayer,
    },
    data() {
      return {
        svgmask: false,
        chartmask: false,
        //PCS功率曲线
        proportionDataLine: {
          grid: {
            top: 20,
            bottom: 20,
            left: 40,
            right: 20,
            containLabel: false // 是否包含坐标轴刻度标签，默认为false
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "shadow",
            },
          },
          color: ["#3286ff"],
          legend: {
            data: [],
            right: 10,
            textStyle: {
              fontSize: 12,
              color: '#fff'
            },
          },
          xAxis: {
            splitLine: {  // 控制x轴网格线颜色
              show: true,
              lineStyle: {
                color: '#082247',
              }
            },
            axisLine: {
              lineStyle: {
                color: '#082247' // 修改刻度线颜色为蓝色
              }
            },
            type: 'category',
            data: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23],
            axisLabel: {
              rotate: 0,
              textStyle: {
                color: '#CCCCCC'
              }
            },
          },
          yAxis: {
            splitLine: {  // 控制x轴网格线颜色
              show: true,
              lineStyle: {
                color: '#082247',
              }
            },
            type: "value",
            axisLabel: {
              interval: 0,
              rotate: 0,
              inside: false,
              textStyle: {
                color: '#CCCCCC'
              },
            },
            axisLine: {
              lineStyle: {
                color: '#082247' // 修改刻度线颜色为蓝色
              }
            }
          },
          series: [
            {
              name: "",
              data: [40, 41, 43, 44, 42, 46, 44, 42, 45, 48, 46, 45, 45, 43, 44, 46, 42, 43, 41, 40, 46],
              type: "line",
              symbol: 'none', // 去掉小圆点
              smooth: true

            },

          ],
        },
        //月度充放电
        proportionDataBar: {
          grid: {
            top: 75,
            bottom: 20,
            left: 30,
            right: 10,
            containLabel: false // 是否包含坐标轴刻度标签，默认为false
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "shadow",
            },
          },
          color: ["#33f1e6", '#ffa114'],
          legend: {
            itemWidth: 10, // 修改图例宽度为20px
            itemHeight: 10, // 修改图例高度为20px
            data: ['充电', '放电'],
            right: 0,
            top: 10,
            textStyle: {
              fontSize: 13,
              color: '#fff',
            },
          },
          xAxis: {
            splitLine: {  // 控制x轴网格线颜色
              show: true,
              lineStyle: {
                color: '#082247',
              }
            },
            axisLine: {
              lineStyle: {
                color: '#082247' // 修改刻度线颜色为蓝色
              }
            },
            type: 'category',
            data: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31],
            axisLabel: {
              // interval: 0, // 所有标签都显示
              // rotate: -45, // 标签倾斜角度
              rotate: 0,
              textStyle: {
                color: '#CCCCCC'
              }
            },
            axisPointer: {
              type: 'shadow' // 在柱状图上方显示阴影指示器
            },
          },
          yAxis: {
            splitLine: {  // 控制x轴网格线颜色
              show: true,
              lineStyle: {
                color: '#082247',
              }
            },
            type: "value",
            axisLabel: {
              interval: 0,
              rotate: 0,
              inside: false,
              textStyle: {
                color: '#CCCCCC'
              },
            },
            axisLine: {
              lineStyle: {
                color: '#082247' // 修改刻度线颜色为蓝色
              }
            }
          },
          dataZoom: [
            {
              type: 'inside', // 滚动条类型
              show: false, // 显示滚动条
              start: 0, // 起始位置
              end: 20, // 结束位置
              bottom: 10 // 滚动条距离底部的距离
            }
          ],
          series: [
            {
              name: "充电",
              data: [10, 20, 30, 10, 50, 60, 30, 40, 15, 10],
              type: "bar",
              smooth: true,
              barWidth: '12' // 设置柱的宽度为 30%
            },
            {
              name: "放电",
              data: [10, 20, 30, 10, 50, 60, 30, 40, 15, 10],
              type: "bar",
              smooth: true,
              barWidth: '12' // 设置柱的宽度为 30%
            },

          ],
        },
        //月度充放电
        proportionDataBar2: {
          grid: {
            top: 40,
            bottom: 20,
            left: 30,
            right: 10,
            containLabel: false // 是否包含坐标轴刻度标签，默认为false
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "shadow",
            },
          },
          color: ["#33f1e6", '#ffa114'],
          legend: {
            itemWidth: 10, // 修改图例宽度为20px
            itemHeight: 10, // 修改图例高度为20px
            data: ['充电', '放电'],
            right: 0,
            top: 10,
            textStyle: {
              fontSize: 13,
              color: '#fff',
            },
          },
          xAxis: {
            splitLine: {  // 控制x轴网格线颜色
              show: true,
              lineStyle: {
                color: '#082247',
              }
            },
            axisLine: {
              lineStyle: {
                color: '#082247' // 修改刻度线颜色为蓝色
              }
            },
            type: 'category',
            data: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31],
            axisLabel: {
              // interval: 0, // 所有标签都显示
              // rotate: -45, // 标签倾斜角度
              rotate: 0,
              textStyle: {
                color: '#CCCCCC'
              }
            },
            axisPointer: {
              type: 'shadow' // 在柱状图上方显示阴影指示器
            },
          },
          yAxis: {
            splitLine: {  // 控制x轴网格线颜色
              show: true,
              lineStyle: {
                color: '#082247',
              }
            },
            type: "value",
            axisLabel: {
              interval: 0,
              rotate: 0,
              inside: false,
              textStyle: {
                color: '#CCCCCC'
              },
            },
            axisLine: {
              lineStyle: {
                color: '#082247' // 修改刻度线颜色为蓝色
              }
            }
          },

          series: [
            {
              name: "充电",
              data: [10, 20, 30, 10, 50, 60, 30, 40, 15, 10],
              type: "bar",
              smooth: true,
              barWidth: '12' // 设置柱的宽度为 30%
            },
            {
              name: "放电",
              data: [10, 20, 30, 10, 50, 60, 30, 40, 15, 10],
              type: "bar",
              smooth: true,
              barWidth: '12' // 设置柱的宽度为 30%
            },

          ],
        },
        realPath: "",
        dataStatistics: {
          "今日收益": 0,
          "pcs.交流日放电量": 0,
          "pcs.交流日充电量": 0,
          "总收益": 0,
          "pcs.交流历史充电量": 0,
          "pcs.交流历史放电量": 0
        },//数据统计
        value1: 0,
        value2: 0,
        value3: 0,
        value4: 0,
        value5: 0,
        value6: 0,
        timer: null

      };
    },

    mounted() {
      this.init()
      // this.requestFullscreen()
      this.realPath = "/static/svgFile/" + '温度在线监测1.wdr.svg'
      this.getDatammm()
      var that = this
      this.timer = setInterval(() => {
        that.getDatammm()
      }, 60000)
    },
    beforeDestroy() {
      // 停止定时器
      clearInterval(this.timer);
    },
    watch: {

      chartmask(val) {
        // if(val){
        //     proportionMask.resize()
        // }
      },
      realPath() {
        this.tran_fn()
      },
      svgmask(val) {
        // if(val){
        //     const iframe2=document.querySelectorAll(".iframe")[1]
        //     iframe2.addEventListener('load',() => {
        //       const svgDoc=iframe2.contentDocument
        //       const svgEl=svgDoc.querySelector('svg')
        //       const gEl=svgDoc.querySelectorAll('g')
        //       for(let i=0;i<gEl.length;i++) {
        //         if(gEl[i].getAttribute('to')&&gEl[i].getAttribute('to')=='body开始 有它kitfox java版本的快会快') {
        //           var rescEl=gEl[i].querySelector('rect')
        //           rescEl.style.fill='transparent'
        //         }
        //       }
        //       svgEl.style.backgroundColor='transparent'   // 修改SVG图的fill颜色为透明色
        //     })
        // }
      },

    },
    // 
    methods: {
      //一分钟
      getDatammm() {
        function getRandomInt(min, max) {
          min = Math.ceil(min);
          max = Math.floor(max);
          return Math.floor(Math.random() * (max - min + 1)) + min;
        }

        this.value1 = getRandomInt(40, 50);
        this.value2 = getRandomInt(40, 50);
        this.value3 = getRandomInt(40, 50);
        this.value4 = getRandomInt(90, 99);
        this.value5 = getRandomInt(90, 99);
        this.value6 = getRandomInt(90, 99);

      },
      //初始化图表
      init() {
        //PCS功率曲线
        proportion = echarts.init(document.getElementById("energy"));
        proportion.setOption(this.proportionDataLine, true);
        //月度充放电
        proportion2 = echarts.init(document.getElementById("energy2"));
        proportion2.setOption(this.proportionDataLine, true);

      },
      //SVG背景透明
      tran_fn() {
        const iframe = document.querySelector(".iframe")
        iframe.addEventListener('load', () => {
          const svgDoc = iframe.contentDocument
          const svgEl = svgDoc.querySelector('svg')
          const gEl = svgDoc.querySelectorAll('g')
          for (let i = 0; i < gEl.length; i++) {
            if (gEl[i].getAttribute('to') && gEl[i].getAttribute('to') == 'body开始 有它kitfox java版本的快会快') {
              var rescEl = gEl[i].querySelector('rect')
              rescEl.style.fill = 'transparent'
            }
          }
          svgEl.style.backgroundColor = 'transparent'   // 修改SVG图的fill颜色为透明色
        })


        const iframe2 = document.querySelectorAll(".iframe")[1]
        iframe2.addEventListener('load', () => {
          const svgDoc = iframe2.contentDocument
          const svgEl = svgDoc.querySelector('svg')
          const gEl = svgDoc.querySelectorAll('g')
          for (let i = 0; i < gEl.length; i++) {
            if (gEl[i].getAttribute('to') && gEl[i].getAttribute('to') == 'body开始 有它kitfox java版本的快会快') {
              var rescEl = gEl[i].querySelector('rect')
              rescEl.style.fill = 'transparent'
            }
          }
          svgEl.style.backgroundColor = 'transparent'   // 修改SVG图的fill颜色为透明色
        })
      },
      getData() {
        findMonPowerKanBan().then(res => {
          if (res.code == 200) {
            this.dataStatistics = res.data
          }
        })
      },
      // 全屏展示
      fullScreen() {
        if (this.isFullscreen() == false) {
          var el = document.documentElement;
          var rfs = el.requestFullScreen || el.webkitRequestFullScreen || el.mozRequestFullScreen || el.msRequestFullscreen;
          if (typeof rfs != "undefined" && rfs) {
            rfs.call(el);
          };
        } else {
          if (document.exitFullscreen) {
            document.exitFullscreen();
          } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
          } else if (document.webkitCancelFullScreen) {
            document.webkitCancelFullScreen();
          } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
          }
          if (typeof cfs != "undefined" && cfs) {
            cfs.call(el);
          }
        }
      },
      // 判断当前是否支持全屏显示
      isFullscreen() {
        return document.fullscreenElement ||
          document.msFullscreenElement ||
          document.mozFullScreenElement ||
          document.webkitFullscreenElement || false;
      },

    },
  };
</script>
<style lang="scss" scoped>
  .system-overview {
    width: 100%;
    height: 100%;
    background: #000;
    box-sizing: border-box;
    padding: 10px;


    .enlarge-img {
      position: absolute;
      top: 42px;
      right: 12px;
    }

    .con {
      width: 100%;
      height: 100%;
    }

    .con-top {
      width: 100%;
      height: calc(50% - 6px);
      //   background-color: red;
      display: flex;

      .system-item {
        flex: 1;
        background: url(../../assets/unifyImg/wendu/dise.png) no-repeat;
        background-size: 100% 100%;

        .item-telte {
          width: 100%;
          height: 42px;
          line-height: 42px;
          background: url(../../assets/unifyImg/wendu/mytitle.png) no-repeat;
          background-size: 100% 100%;

          span {
            font-size: 16px;
            font-weight: bold;
            color: #fff;
            margin-left: 27px;
          }
        }
      }

      .statistics {
        .item-con {
          padding: 12px;
          width: 100%;
          height: calc(100% - 42px);
          box-sizing: border-box;
        }

        .statistics-item {
          width: 100%;
          height: 31%;
          margin-bottom: 12px;
          display: flex;
          align-items: center;
          padding-left: 20px;
          box-sizing: border-box;
          justify-content: space-between;

          .middle-num {
            width: 90px;
            position: relative;

            .explain {
              color: #fff;
              font-size: 13px;
              margin-bottom: 4px;
              text-align: center;
            }

            .allnum {
              font-size: 18px;
              font-weight: bold;
              text-align: center;

              span {
                font-size: 13px;
              }
            }

            img {
              width: 100%;
              height: 2px;
              position: absolute;
              bottom: -2px;
              left: 0;
            }
          }

          .mimmm {
            margin: 0px 25px 0px 25px;
          }

          .left-img {
            width: 107px;
            display: flex;
            align-items: center;

            span {
              color: #FFAA2B;
              font-size: 16px;
              margin-left: 8px;
            }
          }
        }

        .data1 {
          background: url(../../assets/unifyImg/data1.png) no-repeat;
          background-size: 100% 100%;

          .allnum {
            color: #FFA114;

            span {
              color: #FFA114;
            }
          }
        }

        .data2 {
          background: url(../../assets/unifyImg/data2.png) no-repeat;
          background-size: 100% 100%;

          .allnum {
            color: #3286FF;

            span {
              color: #3286FF;
            }
          }
        }

        .data3 {
          background: url(../../assets/unifyImg/data3.png) no-repeat;
          background-size: 100% 100%;

          .allnum {
            color: #36FFF3;

            span {
              color: #36FFF3;
            }
          }
        }
      }

      .system-itemM {
        margin: 0px 12px;

        .svg-con {
          width: 100%;
          height: calc(100% - 42px);
          padding: 12px;
          box-sizing: border-box;
          position: relative;

          .webSvgPlayer {
            width: 100%;
            height: 100%;
          }

          img {
            position: absolute;
            top: 20px;
            right: 12px;
            cursor: pointer;

          }
        }


      }

      .device-items {
        width: 100%;
        height: calc(100% - 42px);
        padding: 12px;
        box-sizing: border-box;
        display: flex;
        flex-wrap: wrap;

        justify-content: space-between;

        .state-item {
          width: calc(50% - 8px);
          height: 31%;
          background: url(../../assets/unifyImg/deviceModu.png) no-repeat;
          background-size: 100% 100%;
          display: flex;
          align-items: center;
          margin-bottom: 12px;

          .left-img {
            margin-left: 20px;
            margin-right: 20px;

          }

          .right-explain {
            p {
              font-size: 13px;
              color: #ffffff;
              margin-bottom: 6px;
            }

            .num {
              font-size: 24px;
              font-weight: bold;
              color: #3286FF;

              span {
                font-size: 24px;
                font-weight: bold;
                color: #3286FF;
                margin-left: 5px;
              }
            }
          }
        }

        .mystate {
          display: flex;
          align-items: center;

          span {
            font-size: 16px;
            font-weight: bold;
            margin-left: 8px;
          }
        }

        .mystop {
          span {
            color: #FF2C2C;
          }
        }

        .myruning {
          span {
            color: #0AD975;
          }
        }

        .marn-right {
          margin-right: 12px;
        }
      }

    }

    .con-bottom {
      width: 100%;
      height: calc(50% - 6px);
      display: flex;
      margin-top: 12px;

      .system-item {
        flex: 1;
        background: url(../../assets/unifyImg/wendu/dise.png) no-repeat;
        background-size: 100% 100%;

        .item-telte {
          width: 100%;
          height: 42px;
          line-height: 42px;
          background: url(../../assets/unifyImg/wendu/mytitle.png) no-repeat;
          background-size: 100% 100%;

          span {
            font-size: 16px;
            font-weight: bold;
            color: #fff;
            margin-left: 27px;
          }
        }
      }

      .mychart {
        width: 100%;
        height: calc(100% - 65px);
        //  padding: 17px 12px 12px 12px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .mylist {
        width: 100%;
        height: calc(100% - 40px);
        padding: 20px 12px;
        box-sizing: border-box;

        .alarm-item {
          display: flex;
          justify-content: space-between;
          color: #fff;
          margin-bottom: 20px;

          .alarm-con {
            font-size: 14px;
            flex: 1;
            white-space: nowrap;
            /* 防止文本换行 */
            overflow: hidden;
            /* 隐藏超出部分 */
            text-overflow: ellipsis;
            /* 显示省略号 */
          }

          .alarm-timer {
            font-size: 13px;
            color: #999999;
            width: 85px;
          }

        }
      }

      p.myname {
        color: #3286FF;
        font-size: 14px;
        text-align: center;
      }

      div.myname {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        color: #0AD975;

        img {
          margin-right: 4px;
        }
      }

      .system-itemM {
        margin: 0px 12px;

        .mychart {
          //  padding: 12px;
          // display: flex;
          // align-items: center;
          // justify-content: center;
        }
      }

    }

    .mymask {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background-color: #191919;
      display: flex;
      align-items: center;
      justify-content: center;

      .closeimg {
        position: absolute;
        top: 40px;
        right: 40px;
        z-index: 9999;

        img {
          cursor: pointer;

        }
      }

      .svg-con {
        width: 1200px;
        height: 600px;
        background-color: #050f1b;

        .webSvgPlayer {
          width: 100%;
          height: 100%;
        }
      }

      .mychart-con {
        padding: 20px;
        box-sizing: border-box;
      }
    }
  }
</style>